// subscribeSync.js
var SubscribeSync = pc.createScript('subscribeSync');

// initialize code called once per entity
SubscribeSync.prototype.initialize = function() {
    this.anim = this.entity.animation;
    this.app.on('reTrigger', this.retrig, this);
};

SubscribeSync.prototype.retrig = function() {
    this.anim.play('Take 001.glb');
};

// update code called every frame
SubscribeSync.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// SubscribeSync.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

